import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useLogin: undefined;
	useLogout: undefined;
	useSignup: undefined;
	useGetOtp: undefined;
	useVerifyOtp: undefined;
	useForgetPasswordRequest: undefined;
	useForgetPassword: undefined;
}

const AUTH_SERVICE_KEYS = createReactQueryKeys<KeyTypes>("auth", [
	"useLogin",
	"useLogout",
	"useSignup",
	"useGetOtp",
	"useVerifyOtp",
	"useForgetPasswordRequest",
	"useForgetPassword",
]);

export { AUTH_SERVICE_KEYS };
